import { render, staticRenderFns } from "./EditarEstudiosDialogComponent.vue?vue&type=template&id=203e764e"
import script from "./EditarEstudiosDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarEstudiosDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports